<template>
  <div class="user">
    <IconSeptima style="position: absolute; right: 20px; top: 20px;"></IconSeptima>
    <Avatar :interactive="false" class="avatar" v-bind:user="user" />
    <div v-if="this.user"><span>Brugernavn: </span><span>{{this.user.userName}}</span></div>
    <div v-if="this.user"><span>Kommune: </span><span>({{this.kommune.kode}}) {{this.kommune.navn}} kommune</span></div>
    <div v-if="this.user.allKommuner">
      <div class="skiftHeader">Skift kommune:</div>
      <select v-model="selectedKommune">
        <option v-for="kom in this.kommuner" v-bind:key="kom.kode" v-bind:value="kom.kode">
          ({{ kom.kode }}) {{ kom.navn }}
        </option>
      </select>
    </div>
    <Button id="logout-button" :onClick="this.onLogout" :text="'Log ud'" />
  </div>
</template>

<script>
import { signin, signout } from '@/auth';
import DawaApi from '@/api/Dawa';
import Avatar from '@/components/Avatar.vue';
import Button from '@/components/common/Button.vue';
import IconSeptima from '@/components/common/Icon/IconSeptima/IconSeptima.vue';

export default {
  name: 'user',
  components: {
    Avatar,
    Button,
    IconSeptima,
  },
  computed: {
    user () {
      return this.$store.state.user;
    },
    kommune () {
      return this.$store.state.kommune;
    },
  },
  data () {
    return {
      kommuner: null,
      selectedKommune: '',
    };
  },
  watch: {
    selectedKommune: function (val) {
      const kommune = this.kommuner.find(k => k.kode === val);
      this.$store.commit('updateKommune', val);
      localStorage.setItem('kommune', JSON.stringify({ kode: val, navn: kommune.navn }));
      this.$store.commit('removeAllGeoDkObjekter');
    },
  },
  methods: {
    onLogin () {
      signin((isAuthenticated, user) => {
        console.log(isAuthenticated);
        console.log(user);
      });
    },
    onLogout () {
      signout();
    },
  },
  mounted () {
    if (this.user.allKommuner) {
      DawaApi.getKommuner()
        .then(response => {
          this.kommuner = response;
          const localStorageKommune = localStorage.getItem('kommune');
          if (localStorageKommune) {
            this.selectedKommune = JSON.parse(localStorageKommune).kode;
          } else {
            this.selectedKommune = this.kommune.kode;
          }
        });
    }
  },
};
</script>

<style lang="scss" scoped>
.user {
  display: flex;
  flex: 1;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

button {
  margin-top: 50px;
}

span:nth-child(2) {
  font-weight: 600;
}

.avatar {
  margin-bottom: 20px;
}

select {
  font-family: 'Open Sans', 'sans-serif';
  font-size: 14px;
  padding: 5px;
}
.skiftHeader {
  margin-top: 20px;
}

#logout-button {
  position: absolute;
  right: 10px;
  bottom: 10px;
}
</style>
